"use strict";

// ==============================
//  THEME SCRIPTS
//  Main file for javascript consolidation. Do not write any javascript in this
//  file! Only include other modules as required.
//  Author: Diff - Foxpod
//  Please review practices documentation before contributing.
// ==============================

// ------------------------------
// MODULES
// ------------------------------


// ------------------------------
// DATA STORES
// ------------------------------


// ------------------------------
// PARTIALS
// ------------------------------

// This is the JSONP callback function for the Mailchimp Ajax request. Must be defined globally.
function displayMailChimpResponse(resp) {
	var message = resp.msg;
	$(".js-newsletter-response").html(message).show();
}

(function ($) {
	// send an AJAX Post request to the mailchimp server, adding this subscriber to the main list. We'll get back a JSONP response with the callback function that we specified in the 'c' parameter.
	$(document).on("submit", ".js-footer-newsletter-form", function (e) {
		e.preventDefault();
		var $form = $(this);
		var newsLetterSignupURL = $form.attr("action");
		newsLetterSignupURL = newsLetterSignupURL.replace("/post?u=", "/post-json?u=");
		newsLetterSignupURL = newsLetterSignupURL + "&c=displayMailChimpResponse";

		$.post(newsLetterSignupURL, $form.serialize(), null, "jsonp");
	});
})(jQuery);

(function ($) {
	$(document).on("product:added", function (event) {
		var quantity = event.detail.quantity;
		var tags = event.detail.tags || [];
		var bogo_meta = tags.filter(hasKeyword);

		if (bogo_meta.length == 2) {
			var bogo_variant_id = getBogoVariantId(bogo_meta);

			var detail = {
				id: bogo_variant_id,
				quantity: quantity
			};

			$.getJSON("/cart.js", function (response) {
				var cart_items = response.items;

				var has_bogo_item = cart_items.some(function (item) {
					return item.id.toString() === bogo_variant_id;
				});

				$.post("/cart/add.js", detail).then(function (response) {
					event.target.dispatchEvent(new CustomEvent('product:added', {
						bubbles: true,
						detail: detail
					}));
				});
			});
		}
	});

	$(document).on("theme:flyout:updated", function (event) {
		var variant_id = event.detail.getAttribute('data-line-id');
		var quantity = parseInt(event.detail.getAttribute('data-quantity'));
		var tags = event.detail.getAttribute('data-tags').split(',');
		debugger;
		var meta = tags.filter(hasKeyword);
		var bogo_variant_id = getBogoVariantId(meta);

		var detail = {
			id: bogo_variant_id,
			quantity: quantity
		};

		$.post('/cart/change.js', detail, 'json').then(function (response) {
			rerenderCart();
		});
	});

	function rerenderCart(elementToAnimate) {
		document.dispatchEvent(new Event('cart:refresh'));
	}

	function hasKeyword(tag) {
		return tag.includes("__bogo");
	}

	function getBogoVariantId(tags) {
		var tag_id = tags.filter(function (tag) {
			return tag.includes("__bogo_id:");
		});

		return tag_id[0].substr(10);
	}
})(jQuery);

(function ($) {
	$(document).on('click', '.js-close-search', function () {
		var $search_button = $('.js-close-search');
		var $search_container = $search_button.closest('.HorizontalList__Item');
		var $mega_menu = $search_button.closest('.MegaMenu');
		$search_container.toggleClass('is-expanded');
		$mega_menu.attr('aria-hidden', 'true');
	});
})(jQuery);